import { render, staticRenderFns } from "./MenuPos.vue?vue&type=template&id=12baabe2&scoped=true&"
var script = {}
import style0 from "./MenuPos.vue?vue&type=style&index=0&id=12baabe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12baabe2",
  null
  
)

export default component.exports